import React from 'react'
import _ from 'lodash'
import { changePassword } from '../../../../redux/user/helpers'

import './style.css'

class ChangePassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    if (this.state.changeSuccess)
      return (
        <div className="change-password centered padded">
          <h2>Your password has been updated!</h2>
        </div>
      )

    return (
      <div className="change-password centered padded">
        <h2>Change Your Password</h2>
        <form
          name="updatePasswordForm"
          className="update-password-form"
          onSubmit={ e => this.handleSubmit(e) } noValidate>
          <label id="currentPasswordLabel">Current Password</label>
          <input 
            type="password" 
            name="currentPassword"
            placeholder="CURRENT PASSWORD"
            ref={ e => this.currentPasswordInput = e }
            autoComplete="false"
            required />

          <label id="newPasswordLabel">New Password</label>
          <input
            type="password" 
            name="newPassword"
            ref={ e => this.newPasswordInput = e }
            placeholder="NEW PASSWORD"
            autoComplete="false"
            required />

          <label id="confirmPasswordLabel">Confirm New Password</label>
          <input
            type="password"
            ref={ e => this.confirmPasswordInput = e }
            name="confirmPassword"
            placeholder="CONFIRM PASSWORD"
            autoComplete="false"
            required />
          { this.state.error && (<div className="error">{ this.state.error }</div>) }
          <div className="text-center">
            <input
              type="submit"
              className={'button cta' + (this.state.processing ? ' processing': '') }
              value="Update"/>
          </div>
        </form>
      </div>
    )
  }

  handleSubmit(e) {
    e.preventDefault()
    if (!this.validate())
      return

    this.setState({...this.state, processing: true })

    changePassword({
      newPassword: this.newPasswordInput.value,
      oldPassword: this.currentPasswordInput.value,
    }).then((response) => {
      this.setState({...this.state, changeSuccess: true })
    }).catch(e =>{
      var x =
        (((e || {}).response || {}).data || {}).error ||
        'We are unable to update your password.'
      this.displayError(x)
    }).then(_ => {
      this.setState({...this.state, processing: false })
    })
  }

  displayError(e) {
    this.setState({...this.state, error: e })
    setTimeout(_ => this.setState({...this.state, error: null }), 5000)
  }

  validate() {
    if (!this.newPasswordInput.value || this.newPasswordInput.value.length <= 4 ) {
      this.displayError('Your new password should be longer than 4 chars')
      return false
    }

    if (this.confirmPasswordInput.value !== this.newPasswordInput.value) {
      this.displayError('Your new passwords don\'t match.')
      return false
    }

    return true
  }
}

export default ChangePassword;
